import { render, staticRenderFns } from "./ReportHealthAndSafetyManagementCost.vue?vue&type=template&id=120c5a1d&scoped=true&"
import script from "./ReportHealthAndSafetyManagementCost.vue?vue&type=script&lang=js&"
export * from "./ReportHealthAndSafetyManagementCost.vue?vue&type=script&lang=js&"
import style0 from "./ReportHealthAndSafetyManagementCost.vue?vue&type=style&index=0&id=120c5a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c5a1d",
  null
  
)

export default component.exports